import Izzi51 from './Izzi 5 (1).webp'
import Izzi52 from './Izzi 5 (2).webp'
import Izzi53 from './Izzi 5 (3).webp'
import Izzi54 from './Izzi 5 (4).webp'
import Izzi55 from './Izzi 5 (5).webp'
import Izzi56 from './Izzi 5 (6).webp'
import Izzi57 from './Izzi 5 (7).webp'
import Izzi58 from './Izzi 5 (8).webp'


const Izzi5images =[
Izzi51,Izzi52,Izzi53,Izzi54,Izzi55,Izzi56,Izzi57,Izzi58
]

export default Izzi5images;
